import React, { memo } from 'react';
import classnames from 'classnames/bind';
import styles from "./styles.pcss";
import { useIsDesktopDimension } from "../../../hooks/useGetDimensionGroup";
import { DesktopText } from "./components/DesktopText";
import { MobileText } from "./components/MobileText";
import { SizeInfo } from "./components/SizeInfo";
import { FilesInput } from "./components/FilesInput";
var cn = classnames.bind(styles);
export var Uploader = /*#__PURE__*/memo(function (_ref) {
  var dragging = _ref.dragging,
    handleChange = _ref.handleChange,
    allowedTypes = _ref.allowedTypes,
    maxFileSize = _ref.maxFileSize,
    errorMessage = _ref.errorMessage,
    id = _ref.id,
    multiple = _ref.multiple;
  var isDesktop = useIsDesktopDimension();
  return /*#__PURE__*/React.createElement("div", {
    className: cn('file-uploader', {
      dragging: dragging,
      'file-uploader--error': errorMessage
    }),
    "data-t-id": "components-Uploader"
  }, isDesktop ? /*#__PURE__*/React.createElement(DesktopText, null) : /*#__PURE__*/React.createElement(MobileText, null), /*#__PURE__*/React.createElement(SizeInfo, {
    allowedTypes: allowedTypes,
    maxFileSize: maxFileSize
  }), /*#__PURE__*/React.createElement(FilesInput, {
    allowedTypes: allowedTypes,
    handleChange: handleChange,
    id: id,
    multiple: multiple
  }));
});